/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
// eslint-disable-next-line no-use-before-define
import React, {
  ReactElement,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';

import './styles.less';
import { SvgComponent } from 'shared/components';
import { Badge, Dropdown, MenuProps, Modal, Popover } from 'antd';
import dayjs from 'dayjs';
import { t } from 'i18next';
import profilePatch from 'pages/profile/profile.service';
import getCurrentUser from 'routes/routes.service';
import { ApplicationState } from 'store/combineReducers';
import { useSelector } from 'react-redux';
import {
  CaretDownOutlined,
  WarningFilled,
  WarningOutlined,
} from '@ant-design/icons';
import { successMessage } from 'utils/api';
import { useHistory } from 'react-router-dom';
import { config } from 'core/config';
import { MessageDataModel, WsLinkType, creatWs } from './utils/wsUtil';
import {
  // addQueueListener,
  clearQueue,
  playAlertAudioQuery,
  removeQueueListener,
} from './utils/alertUtil';

const { dashboardRpmAlert } = config.paths;

export default function GlobalMessage(): ReactElement {
  const history = useHistory();
  const user = useSelector((state: ApplicationState) => state.session?.user);
  const [wsLinkSuccess, setWsLinkSuccess] = useState<boolean>();
  const [data, setData] = useState<MessageDataModel>();
  const [alertPatientCount, setAlertPatientCount] = useState(0);
  const [alertCount, setAlertCount] = useState(0);
  const [open, setOpen] = useState(false);
  const [noNewAlert, setNoNewAlert] = useState(false);

  const handleNewMessage = useCallback((data_?: MessageDataModel) => {
    setWsLinkSuccess(true);
    setData(data_);
    const alertPatientCount_ = data_?.alertPatientCount;
    const alertCount_ = data_?.alertCount || 0;
    if (alertPatientCount_ != null) {
      setAlertPatientCount(alertPatientCount_);
    }
    if (alertCount_ != null) {
      setAlertCount(alertCount_);
      if (alertCount_ === 0) {
        clearQueue();
        setNoNewAlert(true);
      }
    }
    if (data_?.isAudio) {
      if (data_?.audioQueue != null) {
        playAlertAudioQuery(data_?.audioQueue);
        if (data_.audioQueue.length > 0) {
          setNoNewAlert(false);
        } else {
          setNoNewAlert(true);
        }
      }
    } else {
      setNoNewAlert(true);
    }
  }, []);

  function updateWsLinkType(
    type: WsLinkType.MESSAGE | WsLinkType.ERROR | WsLinkType.CLOSE,
    data_?: MessageDataModel,
  ): void {
    if (type === WsLinkType.ERROR || type === WsLinkType.CLOSE) {
      setWsLinkSuccess(false);
      clearQueue();
    }
    if (type === WsLinkType.MESSAGE) {
      handleNewMessage(data_);
    }
  }

  const creatMonitor = useCallback(() => {
    creatWs({
      updateWsLinkType,
    });
    setWsLinkSuccess(true);
  }, []);

  const timer = useRef<any>();

  useEffect(() => {
    if (wsLinkSuccess != null && !wsLinkSuccess) {
      timer.current = setInterval(async () => {
        console.log('检测连接状态', dayjs().format('YYYY-MM-DD HH:mm:ss.SSS'));
        creatMonitor();
      }, 5000);
    } else {
      clearInterval(timer.current);
    }
  }, [wsLinkSuccess, timer, creatMonitor]);

  useEffect(() => {
    creatMonitor();
    // addQueueListener();
    return () => {
      // removeQueueListener();
    };
  }, []);

  const handleJumpRpm = useCallback(() => {
    history.push(dashboardRpmAlert);
  }, []);

  const getClassName = useMemo(() => {
    if (!noNewAlert) {
      return 'yahuikeji-global-message-flase yahuikeji-global-message';
    }
    return 'yahuikeji-global-message-no-new-alert yahuikeji-global-message';
  }, [noNewAlert]);

  return (
    <Popover
      trigger={['click']}
      content={
        <div className={getClassName} onClick={handleJumpRpm}>
          <div className="left">
            <div className="yahuikeji-icon">
              <SvgComponent
                iconName="globalMessage"
                width={20}
                height={20}
                className="anticon"
              />
            </div>
            <div className="yahuikeji-title">
              {noNewAlert
                ? t('globalMessage.noNewAlert')
                : t('globalMessage.newAlert')}
              {/* <CaretDownOutlined /> */}
            </div>
          </div>

          <div className="right">
            <div className="title">
              <span className="label">{t('globalMessage.patient')}</span>
              <span className="value">{alertPatientCount}</span>
            </div>
            <div className="title">
              <span className="label">{t('globalMessage.alerts')}</span>
              <span className="value">{alertCount}</span>
            </div>
          </div>
        </div>
      }
    >
      <span
        style={{
          color: noNewAlert ? '#757575' : '#FF3838',
          cursor: 'pointer',
          marginRight: 16,
          marginTop: 6,
        }}
      >
        <SvgComponent
          iconName="globalMessage"
          width={20}
          height={20}
          className="anticon"
        />
      </span>
    </Popover>
  );
}
